import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer id="footer" className="footer light-background">
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 d-flex">
            <i className="bi bi-geo-alt icon" style={{ color: '#7B3F9E' }}></i>
            <div className="address">
              <p>3 Vicarage Road, Stratford London, E15 4HF</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex">
            <i className="bi bi-geo-alt icon" style={{ color: '#7B3F9E' }}></i>
            <div className="address">
              <h4>General</h4>
              <p>3 Vicarage Road, Stratford London, E15 4HF</p>
              <p><strong>College Switchboard:</strong> 0208 555 2999</p>
              <p><strong>Email:</strong> admin@dtkcollege.co.uk</p>
              <p><strong>Fax:</strong> 020 8536 13 11</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 d-flex">
            <i className="bi bi-globe icon" style={{ color: '#7B3F9E' }}></i>
            <div>
              <h4>International students</h4>
              <p>3 Vicarage Road, Stratford London, E15 4HF</p>
              <p><strong>College Switchboard:</strong> +44(0)208 555 2999</p>
              <p><strong>Email:</strong> admin@dtkcollege.co.uk</p>
              <p><strong>Fax:</strong> +44(0)208 536 1331</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container copyright mt-4">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 text-start">
            <div className="footer-logo">
              <img src="/assets/img/dtk_logo.png" alt="DTK College" style={{ height: '60px' }} />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 text-end">
            <p className="mb-0">
              <Link to="/policies" style={{ textDecoration: 'none', marginRight: '1rem', color: '#7B3F9E' }}>Policy</Link>
              Proudly powered by <strong>Switchboard</strong>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
